import React, { useState, useEffect } from "react";
import "../styles/settings/general.css"; // Ensure you have this CSS file
import DarkModeToggle from "../components/DarkModeToggle";

const GeneralSettings = () => {


  return (
    <div className="settings-section">
      <div className="settings-grid">
        {/* Left Column: Title & Theme Options */}
        <div className="settings-left">
          <h3>Theme Settings</h3>
          <p>Light & dark theme </p>

        </div>

        {/* Right Column: Toggle Button */}
        <div className="settings-right">
          <DarkModeToggle />
        </div>
      </div>
    </div>
  );
};

export default GeneralSettings;
